import { Injectable } from "@angular/core";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { map, catchError } from "rxjs/operators";
import { AuthHeaderService } from "../views/authheader.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CreateloadService {
  sendRateconSMS:string;
  getloadsurl: string;
  recurringLoad: string;
  getLoadnumber: String;
  getloadjourneyurl: string;
  getloadscheduleurl: string;
  rateconUpload: string;
  rateconDetails: string;
  rateconList: string;
  rateconUpdateStatus:string;
  rateconEmail:string
  jobEmail:string
  uploadInvoiceUrl:string
  AttachmentsEmail:string
  getPickDrop:string
  updatePickDrop:string
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.getloadsurl = environment.getloadsurl;
    this.sendRateconSMS = environment.sendRateconSMS;
    this.getloadjourneyurl = environment.getloadjourneyurl;
    this.recurringLoad = environment.recurringLoad;
    this.getloadscheduleurl = environment.loadschedule
    this.rateconUpload = environment.rateconUpload;
    this.rateconDetails = environment.rateconDetails
    this.rateconList = environment.rateconList
    this.rateconUpdateStatus = environment.rateconUpdateStatus
    this.rateconEmail = environment.rateconEmail
    this.getPickDrop = environment.getPickDrop
    this.AttachmentsEmail =  environment.AttachmentsEmail
    this.getLoadnumber = environment.getLoadnumber
    this.uploadInvoiceUrl = environment.uploadInvoice
    this.updatePickDrop = environment.updatePickDrop
    this.jobEmail = environment.sendEmailJob

  }

  addLoadData(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getloadsurl, load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadSchedules(params, isOnlyJobLoad = false) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if (isOnlyJobLoad) {
      options.headers.append('is-only-jobload', 'true');
    }
    return this.http.post(this.getloadscheduleurl, params, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  addRecurringLoadData(load) {
    // console.log(JSON.stringify(load));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.recurringLoad, load, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getLoadData(searchOptions?, isJobLoad = false) {
    let url;
    url = this.getloadsurl + '?';
    if (searchOptions) {
      let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
      if (searchOptions) {
        if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
          url = url + "customerId=" + searchOptions["customerId"] + '&';
        }
        if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
          url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
        }
        if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
          url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
        }
        if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
          url = url + "loadStatus=" + searchOptions["invoiceStatus"] + '&';
        }
        if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
          url = url + "fromDate=" + searchOptions["fromDate"] + '&';
        }
        if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
          url = url + "toDate=" + searchOptions["toDate"] + '&';
        }
        if (searchOptions["driverId"] != "" && searchOptions["driverId"] != null) {
          url = url + "driverId=" + searchOptions["driverId"] + '&';
        }
        if (searchOptions["truckId"] != "" && searchOptions["truckId"] != null) {
          url = url + "truckId=" + searchOptions["truckId"] + '&';
        }
        if (searchOptions["trailerId"] != "" && searchOptions["trailerId"] != null) {
          url = url + "trailerId=" + searchOptions["trailerId"] + '&';
        }
        if (searchOptions["dateSearchCriteria"] != "" && searchOptions["dateSearchCriteria"] != null) {
          url = url + "dateSearchCriteria=" + searchOptions["dateSearchCriteria"] + '&';
        }
        if (searchOptions["state"] != "" && searchOptions["state"] != null) {
          url = url + "state=" + searchOptions["stateId"] + '&';
        }
        if(searchOptions["pickupRefNumber"] != "" && searchOptions["pickupRefNumber"] != null){
          url = url + "pickupRefNumber=" + searchOptions["pickupRefNumber"] + '&';
        }
        if(searchOptions["dropOffRefNumber"] != "" && searchOptions["dropOffRefNumber"] != null){
          url = url + "dropOffRefNumber=" + searchOptions["dropOffRefNumber"] + '&';
        }
        url = url + "pageNumber=" + searchOptions["pageNumber"] + "&";
        url = url + "pageSize=" + searchOptions["pageSize"] + "&";
      }
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if (isJobLoad) {
      options.headers.append('is-jobload-needed', "true");
    }
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadDashboard() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getloadsurl + "/loadDashboard", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadDataWithID(loadId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getloadsurl + "?_id=" + loadId, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getLoadJourneyWithID(loadId, loadType = "") {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    if (loadType) {
      options.headers.append('loadType', loadType);
    }
    return this.http.get(this.getloadjourneyurl + "/" + loadId, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  editLoadData(data, id) {
    // console.log(JSON.stringify(data));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.getloadsurl + "/" + id, data, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  patchLoadData(data, id) {
    // console.log(JSON.stringify(data));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.patch(this.getloadsurl , data, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  deleteLoadData(data) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.getloadsurl + "/" + data._id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  sendSmsRatecon(data) {
    // console.log(JSON.stringify(data));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.sendRateconSMS , data, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendSMS(smsInfo) {
    // console.log(JSON.stringify(smsInfo));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getloadsurl + "/sendSms", smsInfo, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createRecurringLoad(recurringLoad: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.recurringLoad, recurringLoad, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getRecurringLoad() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.recurringLoad, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getLoadNumbers(num) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getLoadnumber+num, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  async rateconUploadFunc(formData: any) {

    var resp
    var companyId = localStorage.getItem("selectedCompany")
    await fetch(this.rateconUpload + companyId + "/ratecon",
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          company: companyId,
          reportProgress: "true",
          responseType: "json",
          "enable-cors": "true",
        }
      })
      .then((response) => {
        resp = response.json()
      })
      .catch((err) => {
        console.log('Error ' + err);

      })
    return resp
  }


  getRateconDetails(fileName) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(`${this.rateconDetails}${fileName}`, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  getRateconList(searchOptions?) {
    let url;
    url = this.rateconList + '?';
    if (searchOptions) {
      let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
      if (searchOptions) {
        if (searchOptions["customer"] != "" && searchOptions["customer"] != null) {
          url = url + "customer=" + searchOptions["customer"] + '&';
        }
        if (searchOptions["status"] != "" && searchOptions["status"] != null) {
          url = url + "status=" + searchOptions["status"] + '&';
        }
        if (searchOptions["crefNo"] != "" && searchOptions["crefNo"] != null) {
          url = url + "crefNo=" + searchOptions["crefNo"] + '&';
        }
        if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
          url = url + "fromDate=" + searchOptions["fromDate"] + '&';
        }
        if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
          url = url + "toDate=" + searchOptions["toDate"] + '&';
        }
        url = url + "pageNo=" + searchOptions["pageNumber"] + "&";
        url = url + "pageSize=" + searchOptions["pageSize"] + "&";
      }
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  mapRateconToLoad(data) {
    // console.log(JSON.stringify(data));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.patch(this.rateconList, data, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  saveRatecon(data) {
    // console.log(JSON.stringify(data));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.rateconList, data, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateRateconStatus(data) {
    // console.log(JSON.stringify(data));
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.patch(this.rateconUpdateStatus, data, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  getPickDropdata(obj: any,) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.getPickDrop, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  loadStatusList = [
    {
      ID: 0,
      Type: "Load",
      Name: "Booked",
      disable: false,
    },

    {
      ID: 1,
      Type: "Load",
      Name: "In Transit",
      disable: true,
    },
    {
      ID: 2,
      Type: "Load",
      Name: "Delay",
      disable: true,
    },
    {
      ID: 3,
      Type: "Load",
      Name: "TONU",
      disable: false,
    },
    {
      ID: 4,
      Type: "Load",
      Name: "Cancelled",
      disable: false,
    },
    {
      ID: 5,
      Type: "Load",
      Name: "Delivered",
      disable: true,
    },
    {
      ID: 6,
      Type: "Load",
      Name: "Invoiced",
      disable: false,
    },
    {
      ID: 7,
      Type: "Load",
      Name: "Factored",
      disable: false,
    },
    {
      ID: 0,
      Type: "Job Load",
      Name: "Booked",
      disable: false,
    },

    {
      ID: 1,
      Type: "Job Load",
      Name: "Completed",
      disable: true,
    },
    {
      ID: 2,
      Type: "Job Load",
      Name: "Delay",
      disable: true,
    },
    {
      ID: 3,
      Type: "Job Load",
      Name: "Booked",
      disable: false,
    },
    {
      ID: 4,
      Type: "Job Load",
      Name: "Completed",
      disable: false,
    },
    {
      ID: 5,
      Type: "Job Load",
      Name: "Completed",
      disable: true,
    },
    {
      ID: 6,
      Type: "Job Load",
      Name: "Departed",
      disable: false,
    },
    {
      ID: 7,
      Type: "Job Load",
      Name: "Departed",
      disable: false,
    },
    {
      ID: 8,
      Type: "Job Load",
      Name: "Standby",
      disable: false,
    },
    {
      ID: 0,
      Type: "Pickup",
      Name: "Booked",
    },
    {
      ID: 1,
      Type: "Pickup",
      Name: "On The Way",
    },
    {
      ID: 3,
      Type: "Pickup",
      Name: "On-time",
    },
    {
      ID: 2,
      Type: "Pickup",
      Name: "Truck Delay",
    },
    {
      ID: 4,
      Type: "Pickup",
      Name: "Shipper Delay",
    },
    {
      ID: 5,
      Type: "Pickup",
      Name: "Completed",
    },
    {
      ID: 6,
      Type: "Pickup",
      Name: "Cancelled",
    },
    {
      ID: 0,
      Type: "Dropoff",
      Name: "Booked",
    },
    {
      ID: 1,
      Type: "Dropoff",
      Name: "In Transit",
    },
    {
      ID: 3,
      Type: "Dropoff",
      Name: "On-time",
    },
    {
      ID: 2,
      Type: "Dropoff",
      Name: "Delay",
    },
    {
      ID: 4,
      Type: "Dropoff",
      Name: "Receiving Delay",
    },
    {
      ID: 5,
      Type: "Dropoff",
      Name: "Completed",
    },
    {
      ID: 6,
      Type: "Dropoff",
      Name: "Cancelled",
    },

    {
      ID: 0,
      Type: "Job Pickup",
      Name: "Arrived",
    },
    {
      ID: 1,
      Type: "Job Pickup",
      Name: "Completed",
    },
    // {
    //   ID: 2,
    //   Type: "Job Pickup",
    //   Name: "Delay",
    // },
    {
      ID: 4,
      Type: "Job Pickup",
      Name: "Standby",
    },

    // {
    //   ID: 7,
    //   Type: "Job Pickup",
    //   Name: "Resume StandBy",
    // },
    {
      ID: 8,
      Type: "Job Pickup",
      Name: "Break",
    },
    // {
    //   ID: 9,
    //   Type: "Job Pickup",
    //   Name: "Resume Break",
    // },
    {
      ID: 10,
      Type: "Job Pickup",
      Name: "Break down",
    },
    // {
    //   ID: 11,
    //   Type: "Job Pickup",
    //   Name: "Resume Break down",
    // },
    {
      ID: 6,
      Type: "Job Pickup",
      Name: "Cancelled",
    },


    {
      ID: 0,
      Type: "Job Dropoff",
      Name: "Arrived",
    },
    {
      ID: 1,
      Type: "Job Dropoff",
      Name: "Completed",
    },
    {
      ID: 2,
      Type: "Job Dropoff",
      Name: "Delay",
    },
    {
      ID: 4,
      Type: "Job Dropoff",
      Name: "Standby",
    },

    // {
    //   ID: 7,
    //   Type: "Job Dropoff",
    //   Name: "Resume StandBy",
    // },
    {
      ID: 8,
      Type: "Job Dropoff",
      Name: "Break",
    },
    {
      ID: 10,
      Type: "Job Dropoff",
      Name: "Break down",
    },
    {
      ID: 6,
      Type: "Job Dropoff",
      Name: "Cancelled",
    },

    {
      ID: 3,
      Type: "Invoice",
      Name: "TONU",
      disable: false,
    },
    {
      ID: 4,
      Type: "Invoice",
      Name: "Cancelled",
      disable: false,
    },
    {
      ID: 5,
      Type: "Invoice",
      Name: "Delivered",
      disable: true,
    },
    {
      ID: 6,
      Type: "Invoice",
      Name: "Invoiced",
      disable: false,
    },
    {
      ID: 7,
      Type: "Invoice",
      Name: "Factored",
      disable: false,
    },
    {
      ID: 5,
      Type: "Job Invoice",
      Name: "Delivered",
      disable: true,
    },
    {
      ID: 6,
      Type: "Job Invoice",
      Name: "Invoiced",
      disable: false,
    },
    {
      ID: 7,
      Type: "Job Invoice",
      Name: "Factored",
      disable: false,
    },
  ];

  getLoadStatusList(type) {
    let companyType = localStorage.getItem("companyType");
    if (companyType === 'Dump_Trucks') type = 'Job ' + type;
    if (type != "") {
      return this.loadStatusList.filter((s) => s.Type === type);
    } else {
      return this.loadStatusList;
    }
  }


  getLoadMapData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getloadsurl + "/loadmap", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  async sendRateconEmail(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.rateconEmail,obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  async sendEmailJob(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.jobEmail,obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  uploadInvoice(obj) {
    let compId = localStorage.getItem('selectedCompany')
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.uploadInvoiceUrl+compId+"/invoice",obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  async sendAttachmentsEmail(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.AttachmentsEmail,obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateStatusPickDrop(id, loadId, status, pickDrop, message = null){
    let obj = {
      "loadId": loadId,
      "loadStatus": status,
    }
    if(message){
      obj['delayComments']=message
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.updatePickDrop +pickDrop+ '/' + id, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updatePickDropDriver(payload){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
      });
    return this.http.post(this.getloadsurl + '/updateloadsdriver', payload, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
